var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _g, _path139, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRubixiO16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 432,
    height: 763,
    viewBox: "0 0 432 763",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.67 590.7V625.91L175.67 661.13L175.32 625.91L114.67 590.7Z",
    fill: "#184171",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.67 590.7L138.09 577.55L199.08 612.77L175.32 625.91L114.67 590.7Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.08 612.77V647.99L175.67 661.13L175.32 625.909L199.08 612.77Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.519 623.474C135.568 622.34 135.635 618.541 133.668 614.99C131.702 611.439 128.448 609.479 126.399 610.613C124.35 611.748 124.283 615.546 126.249 619.097C128.216 622.649 131.47 624.608 133.519 623.474Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.638 632.451C150.687 631.317 150.754 627.519 148.787 623.968C146.821 620.416 143.567 618.457 141.518 619.591C139.469 620.725 139.402 624.523 141.369 628.075C143.335 631.626 146.589 633.586 148.638 632.451Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163.887 641.263C165.936 640.129 166.003 636.33 164.037 632.779C162.07 629.228 158.816 627.268 156.767 628.402C154.718 629.537 154.651 633.335 156.618 636.886C158.584 640.438 161.838 642.397 163.887 641.263Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M163.68 612.77L177.12 605.01L190.55 612.77L177.12 620.53L163.68 612.77Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145.17 602.52L158.61 594.76L172.05 602.52L158.61 610.27L145.17 602.52Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.8 591.98L141.24 584.22L154.67 591.98L141.24 599.74L127.8 591.98Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M174.85 625.819V661.039L235.85 696.259L235.49 661.039L174.85 625.819Z",
    fill: "#184171",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M174.85 625.82L198.26 612.68L259.26 647.9L235.49 661.04L174.85 625.82Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M259.259 647.899V683.109L235.849 696.259L235.489 661.039L259.259 647.899Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M193.704 658.6C195.753 657.466 195.82 653.667 193.854 650.116C191.888 646.565 188.633 644.605 186.584 645.739C184.536 646.874 184.469 650.672 186.435 654.223C188.401 657.775 191.656 659.734 193.704 658.6Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M208.804 667.592C210.853 666.458 210.92 662.66 208.954 659.108C206.987 655.557 203.733 653.597 201.684 654.732C199.635 655.866 199.568 659.664 201.535 663.215C203.501 666.767 206.755 668.726 208.804 667.592Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M224.067 676.39C226.115 675.256 226.182 671.457 224.216 667.906C222.25 664.355 218.995 662.395 216.947 663.529C214.898 664.664 214.831 668.462 216.797 672.013C218.763 675.565 222.018 677.524 224.067 676.39Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M223.85 647.9L237.29 640.14L250.73 647.9L237.29 655.66L223.85 647.9Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M205.35 637.64L218.78 629.88L232.22 637.64L218.78 645.4L205.35 637.64Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 627.11L201.41 619.35L214.85 627.11L201.41 634.87L187.97 627.11Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M235.92 660.949V696.169L296.92 731.389L296.57 696.169L235.92 660.949Z",
    fill: "#184171",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M235.92 660.95L259.34 647.81L320.34 683.02L296.57 696.17L235.92 660.95Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M320.34 683.02V718.24L296.92 731.39L296.57 696.169L320.34 683.02Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M254.779 693.744C256.827 692.61 256.894 688.812 254.928 685.261C252.962 681.709 249.707 679.75 247.659 680.884C245.61 682.018 245.543 685.816 247.509 689.368C249.475 692.919 252.73 694.879 254.779 693.744Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M269.882 702.713C271.931 701.579 271.998 697.781 270.032 694.229C268.066 690.678 264.811 688.718 262.762 689.853C260.714 690.987 260.647 694.785 262.613 698.337C264.579 701.888 267.833 703.847 269.882 702.713Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M285.131 711.525C287.18 710.391 287.247 706.592 285.281 703.041C283.315 699.489 280.06 697.53 278.011 698.664C275.963 699.798 275.896 703.597 277.862 707.148C279.828 710.699 283.083 712.659 285.131 711.525Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M284.93 683.02L298.37 675.27L311.81 683.02L298.37 690.78L284.93 683.02Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M266.42 672.77L279.86 665.01L293.3 672.77L279.86 680.53L266.42 672.77Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M249.05 662.24L262.49 654.479L275.92 662.24L262.49 670L249.05 662.24Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M115.23 206.55L299.69 312.36L244.12 344.44L59.6499 238.64L115.23 206.55Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M114.98 77.6504L114.7 205.67L299.88 314.29L299.82 185.95L114.98 77.6504Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3096 245.32L119.98 217.21L132 224.47L83.3296 252.57",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8691 256.23L137.539 228.13L149.559 235.38L100.889 263.49",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M107.14 266.52L155.81 238.42L167.83 245.67L119.16 273.77",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M125.67 277.43L174.34 249.33L186.36 256.59L137.69 284.69",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M144.64 287.42L193.31 259.32L205.33 266.57L156.65 294.68",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M162.199 298.34L210.869 270.24L222.889 277.49L174.219 305.59",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M180.47 308.62L229.14 280.52L241.16 287.78L192.49 315.88",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M199 319.54L247.67 291.44L259.69 298.69L211.02 326.79",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M218.939 330.55L267.619 302.45L279.639 309.7L230.959 337.8",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M236.51 341.47L285.18 313.37L297.2 320.62L248.52 348.72",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M254.77 351.75L303.45 323.65L315.47 330.91L266.79 359.01",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M273.31 362.67L321.98 334.57L334 341.82L285.33 369.92",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M292.27 372.66L340.95 344.56L352.96 351.81L304.29 379.91",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M309.829 383.57L358.509 355.47L370.529 362.73L321.849 390.83",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M284.75 644.61L283.25 623.44C278.64 534.23 278.64 444.84 283.25 355.65L288.6 270.24L290.24 245.2L244.13 217.96V344.44L59.6502 238.64V110.29L12.9502 83.5L8.03016 158.84C1.42016 259.87 0.740156 361.21 5.98016 462.33L12.9502 596.91L59.0202 623.52V497.35L244.12 603.53V731.88L290.23 758.61L288.76 734.51",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M284.75 644.61L283.25 623.44C278.64 534.23 278.64 444.84 283.25 355.65L288.6 270.24L290.24 245.2L244.13 217.96V344.44L59.6502 238.64V110.29L12.9502 83.5L8.03016 158.84C1.42016 259.87 0.740156 361.21 5.98016 462.33L12.9502 596.91L59.0202 623.52V497.35L244.12 603.53V731.88L290.23 758.61L288.76 734.51",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M244.12 668.66L114.67 592V527.9L244.12 604.79V668.66Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8198 238.49L115.4 206.41V78.8301L59.8198 110.91V238.49Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9502 83.49L151.6 2.5L428.88 164.21L290.23 245.2L244.12 217.96L299.82 185.95L115.58 78.46L59.6502 110.29L12.9502 83.49Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M266.13 286.63L290.55 245.27L429.2 164.27V677.69L290.55 758.68L287.22 724.859L284.19 632.729L283.24 351.64L251.32 328.92",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M289.09 734.62L290.23 758.891L428.88 677.891V164.48L290.23 245.47L289.11 270.15",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M289.09 734.62L290.23 758.891L428.88 677.891V164.48L290.23 245.47L289.11 270.15",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M283.24 355.92L281.66 391.15C279.14 446.44 278.61 500.42 280.62 555.73L284.83 644.83",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M283.24 355.92L281.66 391.15C279.14 446.44 278.61 500.42 280.62 555.73L284.83 644.83",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M287.94 710.4L288.37 719.4",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M286.72 684.67L287.22 695.23",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M285.55 659.87L286.01 669.61",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M284.98 333.11L284.64 340.63",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M286.07 309.24L285.7 317.31",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M287.48 285.3L287.06 294.58",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M122.94 18.65L400.74 180.92L401.39 693.95L428.88 677.89V164.48L151.6 2.5L122.94 18.65Z",
    fill: "#D7DCE0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2502 242.25L24.0002 278.77C21.4102 320.72 21.2502 362.78 23.5002 404.74L26.2502 456.11L257.4 590.6L255.27 553.12C252.39 502.3 252.58 451.35 255.84 400.55L257.4 376.3L26.2502 242.25Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M114.67 591.94L59.1 624.03L59.02 495.71L114.67 527.84V591.94Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M288.59 270.51L346.22 238.95V252.58L287.6 285.54L266.85 273.98C264.7 272.79 263.36 270.54 263.32 268.08C263.24 262.77 268.96 259.38 273.58 262L288.58 270.51H288.59Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M287.01 294.64L346.22 263.38V277.01L286.07 309.24L266.57 297.96C264.52 296.78 263.25 294.61 263.21 292.24C263.13 286.95 268.9 283.65 273.42 286.39L287 294.64H287.01Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M285.5 317.71L346.22 286.83V300.46L284.53 332.91L266.3 321.3C264.41 320.09 263.25 318.02 263.21 315.78C263.13 310.47 268.98 307.2 273.46 310.05L285.49 317.71H285.5Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M284.58 341.651L346.22 310.061V323.691L283.24 355.921L266.22 345.011C264.38 343.831 263.25 341.811 263.22 339.621C263.14 334.361 269.01 331.171 273.38 334.111L284.58 341.651Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M288.51 719.5L350.15 687.91V701.54L288.77 734.79L270.15 722.86C268.31 721.68 267.18 719.66 267.15 717.47C267.07 712.21 272.94 709.02 277.31 711.96L288.51 719.5Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M287.331 695.3L348.971 663.71V677.34L287.591 710.59L268.971 698.66C267.131 697.48 266.001 695.46 265.971 693.27C265.891 688.01 271.761 684.82 276.131 687.76L287.331 695.3Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M286.02 669.62L347.66 638.03V651.66L286.28 684.91L267.66 672.98C265.82 671.8 264.69 669.78 264.66 667.59C264.58 662.33 270.45 659.14 274.82 662.08L286.02 669.62Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M284.75 644.88L346.39 613.29V626.92L285.01 660.17L266.39 648.24C264.55 647.06 263.42 645.04 263.39 642.85C263.31 637.59 269.18 634.4 273.55 637.34L284.75 644.88Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7602 111.79L29.3402 122.11C31.2602 123.18 32.4702 125.18 32.5002 127.38C32.5702 132.12 27.4502 135.15 23.3102 132.81L9.7002 125.11",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37006 134.91L27.9501 145.23C29.8701 146.3 31.0801 148.3 31.1101 150.5C31.1801 155.24 26.0601 158.27 21.9201 155.93L8.31006 148.23",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07025 157.521L26.6503 167.84C28.5703 168.91 29.7803 170.911 29.8103 173.111C29.8803 177.851 24.7603 180.88 20.6203 178.54L7.01025 170.84",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6601 180.14L25.2401 190.46C27.1601 191.53 28.3701 193.53 28.4001 195.73C28.4701 200.47 23.3501 203.5 19.2101 201.16L5.6001 193.46",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87988 491.42L26.4599 501.74C28.3799 502.81 29.5899 504.81 29.6199 507.01C29.6899 511.75 24.5699 514.78 20.4299 512.44L8.20988 505.53",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98975 514.97L27.5697 525.29C29.4897 526.36 30.6997 528.36 30.7297 530.56C30.7997 535.3 25.6797 538.33 21.5397 535.99L9.75975 529.33",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87012 538.05L28.4501 548.37C30.3701 549.44 31.5801 551.44 31.6101 553.64C31.6801 558.38 26.5601 561.41 22.4201 559.07L10.6401 552.41",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M11.52 561.53L29.4 571.45C31.32 572.52 32.53 574.52 32.56 576.72C32.63 581.46 27.51 584.49 23.37 582.15L11.85 575.63",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M116.45 43.7598V78.9798L177.45 114.2L177.1 78.9798L116.45 43.7598Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M116.45 43.7601L139.87 30.6201L200.86 65.8401L177.1 78.9801L116.45 43.7601Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M200.861 65.8398V101.05L177.451 114.2L177.101 78.9799L200.861 65.8398Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M135.33 76.5277C137.379 75.3935 137.446 71.5951 135.48 68.0437C133.514 64.4924 130.259 62.5328 128.21 63.667C126.162 64.8012 126.095 68.5997 128.061 72.151C130.027 75.7024 133.282 77.6619 135.33 76.5277Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M150.439 85.5052C152.487 84.371 152.554 80.5726 150.588 77.0213C148.622 73.4699 145.368 71.5104 143.319 72.6446C141.27 73.7788 141.203 77.5772 143.169 81.1286C145.135 84.6799 148.39 86.6394 150.439 85.5052Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M165.694 94.308C167.742 93.1738 167.809 89.3754 165.843 85.824C163.877 82.2726 160.622 80.3131 158.574 81.4473C156.525 82.5815 156.458 86.3799 158.424 89.9313C160.39 93.4827 163.645 95.4422 165.694 94.308Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M165.46 65.8401L178.9 58.0801L192.33 65.8401L178.9 73.6001L165.46 65.8401Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M146.95 55.5803L160.39 47.8203L173.83 55.5803L160.39 63.3403L146.95 55.5803Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M129.58 45.05L143.02 37.29L156.45 45.05L143.02 52.81L129.58 45.05Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M176.63 78.8896V114.11L237.63 149.33L237.27 114.11L176.63 78.8896Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M176.63 78.89L200.04 65.75L261.04 100.96L237.27 114.11L176.63 78.89Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M261.04 100.96V136.18L237.63 149.33L237.27 114.11L261.04 100.96Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M195.515 111.663C197.564 110.529 197.631 106.731 195.664 103.179C193.698 99.6281 190.444 97.6686 188.395 98.8028C186.346 99.937 186.279 103.735 188.246 107.287C190.212 110.838 193.466 112.798 195.515 111.663Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M210.611 120.637C212.659 119.503 212.726 115.704 210.76 112.153C208.794 108.602 205.539 106.642 203.491 107.776C201.442 108.911 201.375 112.709 203.341 116.26C205.307 119.812 208.562 121.771 210.611 120.637Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M225.868 129.444C227.917 128.31 227.984 124.511 226.018 120.96C224.052 117.408 220.797 115.449 218.749 116.583C216.7 117.717 216.633 121.516 218.599 125.067C220.565 128.618 223.82 130.578 225.868 129.444Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M225.63 100.96L239.07 93.21L252.51 100.96L239.07 108.72L225.63 100.96Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M207.13 90.7102L220.56 82.9502L234 90.7102L220.56 98.4702L207.13 90.7102Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M189.75 80.1799L203.19 72.4199L216.63 80.1799L203.19 87.9399L189.75 80.1799Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M237.7 114.021V149.241L298.7 184.451L298.35 149.241L237.7 114.021Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M237.7 114.02L261.12 100.87L322.12 136.09L298.35 149.24L237.7 114.02Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M322.121 136.09V171.31L298.701 184.45L298.351 149.24L322.121 136.09Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M256.575 146.789C258.623 145.655 258.69 141.857 256.724 138.305C254.758 134.754 251.503 132.795 249.455 133.929C247.406 135.063 247.339 138.861 249.305 142.413C251.271 145.964 254.526 147.924 256.575 146.789Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M271.694 155.767C273.742 154.633 273.809 150.834 271.843 147.283C269.877 143.732 266.622 141.772 264.574 142.906C262.525 144.041 262.458 147.839 264.424 151.39C266.39 154.942 269.645 156.901 271.694 155.767Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M286.943 164.578C288.991 163.444 289.058 159.646 287.092 156.095C285.126 152.543 281.871 150.584 279.823 151.718C277.774 152.852 277.707 156.65 279.673 160.202C281.639 163.753 284.894 165.713 286.943 164.578Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M286.71 136.09L300.15 128.33L313.59 136.09L300.15 143.85L286.71 136.09Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M268.2 125.84L281.64 118.08L295.08 125.84L281.64 133.6L268.2 125.84Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M250.83 115.3L264.27 107.55L277.7 115.3L264.27 123.06L250.83 115.3Z",
    fill: "#E0E0E0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M362.45 469.761V535.611L390.97 552.081V486.221L362.45 469.761Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M362.45 469.76L382.86 457.98L411.38 474.44L390.97 486.22L362.45 469.76Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M390.97 486.22V552.08L411.38 540.3V474.44L390.97 486.22Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M395.87 490.71V502.08C395.87 502.81 396.66 503.27 397.3 502.91L407.14 497.23C407.43 497.06 407.62 496.75 407.62 496.4V485.03C407.62 484.3 406.83 483.84 406.19 484.2L396.35 489.88C396.06 490.05 395.87 490.36 395.87 490.71Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M395.87 511.161V522.531C395.87 523.261 396.66 523.72 397.3 523.36L407.14 517.68C407.43 517.51 407.62 517.2 407.62 516.85V505.481C407.62 504.751 406.83 504.29 406.19 504.65L396.35 510.33C396.06 510.5 395.87 510.811 395.87 511.161Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M395.87 530.12V541.49C395.87 542.22 396.66 542.68 397.3 542.32L407.14 536.64C407.43 536.47 407.62 536.16 407.62 535.81V524.44C407.62 523.71 406.83 523.25 406.19 523.61L396.35 529.29C396.06 529.46 395.87 529.77 395.87 530.12Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M366.86 482.181L386.56 493.561",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M366.86 490.36L386.56 501.74",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M366.86 499.9L386.56 511.27",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M366.86 508.08L386.56 519.45",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M366.86 517.131L386.56 528.501",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M366.86 525.311L386.56 536.691",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M362.45 404.24V470.09L390.97 486.55V420.7L362.45 404.24Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M362.45 404.24L382.86 392.45L411.38 408.92L390.97 420.7L362.45 404.24Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M390.97 420.7V486.55L411.38 474.77V408.92L390.97 420.7Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M395.87 425.19V436.56C395.87 437.29 396.66 437.75 397.3 437.39L407.14 431.71C407.43 431.54 407.62 431.23 407.62 430.88V419.51C407.62 418.78 406.83 418.32 406.19 418.68L396.35 424.36C396.06 424.53 395.87 424.84 395.87 425.19Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M395.87 445.64V457.01C395.87 457.74 396.66 458.2 397.3 457.84L407.14 452.16C407.43 451.99 407.62 451.68 407.62 451.33V439.96C407.62 439.23 406.83 438.77 406.19 439.13L396.35 444.81C396.06 444.98 395.87 445.29 395.87 445.64Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M395.87 464.6V475.97C395.87 476.7 396.66 477.16 397.3 476.8L407.14 471.12C407.43 470.95 407.62 470.64 407.62 470.29V458.92C407.62 458.19 406.83 457.73 406.19 458.09L396.35 463.77C396.06 463.94 395.87 464.25 395.87 464.6Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M366.86 416.66L386.56 428.03",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M366.86 424.84L386.56 436.21",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M366.86 434.37L386.56 445.75",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M366.86 442.561L386.56 453.931",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M366.86 451.61L386.56 462.98",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M366.86 459.79L386.56 471.16",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M193.31 391.069C188.56 393.569 187.04 401.799 192.65 413.509C192.73 413.689 192.84 413.859 192.95 414.019C200.58 425.159 208.81 427.739 213.25 424.299",
    fill: "#FBB93E"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M193.31 391.069C188.56 393.569 187.04 401.799 192.65 413.509C192.73 413.689 192.84 413.859 192.95 414.019C200.58 425.159 208.81 427.739 213.25 424.299",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M239.31 386.71C225 365.82 208.55 375.31 219.49 398.15C219.57 398.33 219.68 398.51 219.79 398.67C234.11 419.57 250.55 410.07 239.61 387.23C239.53 387.05 239.42 386.87 239.31 386.71Z",
    fill: "#FBB93E",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M213.24 424.299L236.48 410.889C238.1 409.959 241.43 407.669 242.22 405.749L243.17 401.669L242.78 396.569L241.66 392.259L238.31 385.299L233.72 380.089L229.96 377.199C229.03 375.589 221.92 374.919 220.3 375.839L192.46 391.569",
    fill: "#FBB93E"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M213.24 424.299L236.48 410.889C238.1 409.959 241.43 407.669 242.22 405.749L243.17 401.669L242.78 396.569L241.66 392.259L238.31 385.299L233.72 380.089L229.96 377.199C229.03 375.589 221.92 374.919 220.3 375.839L192.46 391.569",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M212.3 424.689C214.55 423.169 215.93 420.219 215.93 416.129C215.93 407.459 209.74 396.829 202.17 392.489C198.39 390.319 194.94 390.129 192.45 391.549",
    fill: "#FBB93E"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M212.3 424.689C214.55 423.169 215.93 420.219 215.93 416.129C215.93 407.459 209.74 396.829 202.17 392.489C198.39 390.319 194.94 390.129 192.45 391.549",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_934_722",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 271,
    width: 93,
    height: 78
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8901 296.2L41.9601 271.17L133.34 323.92L133.27 348.96L41.8901 296.2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_934_722)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_934_722",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 271,
    width: 93,
    height: 78
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9601 271.17L133.34 323.92L133.27 348.96L41.8901 296.2L41.9601 271.17Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_934_722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.2701 297.51L75.3801 296.42V301.08C75.3701 301.68 75.3701 302.26 75.3801 302.82C75.3901 303.38 75.4001 303.92 75.4201 304.44C75.4401 304.96 75.4601 305.45 75.4901 305.92C75.5101 306.39 75.5401 306.83 75.5801 307.25C75.5801 307.37 75.6001 307.5 75.6101 307.62L68.5401 292.49L66.8501 291.51L66.8101 305.68L68.6901 306.77L68.7101 300.87C68.7101 300.75 68.7101 300.61 68.7101 300.44C68.7101 300.27 68.7001 300.07 68.6901 299.81C68.6801 299.55 68.6601 299.22 68.6301 298.8C68.6101 298.39 68.5701 297.88 68.5301 297.28C68.5001 296.84 68.4701 296.34 68.4301 295.77L75.5101 310.7L77.2401 311.7L77.2801 297.52",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.02 303.8L80.23 302.76L80.21 309.33C80.21 310.2 80.33 311.03 80.59 311.82C80.85 312.61 81.23 313.32 81.7 313.95C82.18 314.57 82.75 315.08 83.4 315.46C83.92 315.77 84.41 315.93 84.87 315.95C85.32 315.98 85.72 315.89 86.05 315.67C86.2 315.57 86.33 315.45 86.44 315.31V317.01L88.24 318.05L88.27 307.42L86.47 306.38L86.45 312.78C86.45 313.16 86.39 313.47 86.27 313.73C86.15 313.99 85.99 314.17 85.79 314.28C85.59 314.4 85.34 314.43 85.06 314.4C84.79 314.37 84.47 314.26 84.14 314.07C83.68 313.8 83.3 313.46 82.98 313.03C82.66 312.6 82.41 312.12 82.25 311.56C82.09 311.02 82 310.42 82 309.8L82.02 303.81",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2798 320.41C94.7298 320.09 94.2498 319.65 93.8298 319.1C93.4098 318.53 93.0798 317.91 92.8398 317.23C92.5998 316.55 92.4798 315.83 92.4798 315.15C92.4798 314.47 92.6098 313.91 92.8498 313.5C93.0898 313.09 93.4298 312.86 93.8498 312.78C94.2698 312.71 94.7498 312.84 95.2998 313.15C95.8498 313.46 96.3298 313.9 96.7498 314.45C97.1698 315.01 97.4898 315.62 97.7298 316.31C97.9698 316.99 98.0798 317.67 98.0798 318.37C98.0798 319.07 97.9498 319.63 97.7098 320.03C97.4698 320.44 97.1298 320.68 96.7098 320.75C96.2898 320.83 95.8098 320.71 95.2798 320.4M92.5998 305.55L90.7998 304.51L90.7598 319.44L92.5598 320.48V319.13C92.7698 319.54 93.0298 319.95 93.3298 320.37C93.6498 320.81 94.0098 321.21 94.3898 321.58C94.7898 321.96 95.1698 322.25 95.5698 322.48C96.3698 322.94 97.0998 323.13 97.7398 323.01C98.3798 322.9 98.8898 322.53 99.2598 321.91C99.6298 321.28 99.8098 320.44 99.8198 319.37C99.8298 318.3 99.6298 317.24 99.2698 316.2C98.8998 315.16 98.3898 314.21 97.7598 313.37C97.1198 312.52 96.3898 311.87 95.5698 311.39C95.1898 311.17 94.8298 311.04 94.4598 310.97C94.0998 310.91 93.7598 310.9 93.4598 310.96C93.1498 311.03 92.8998 311.13 92.6998 311.31C92.6598 311.34 92.6298 311.38 92.5998 311.41L92.6198 305.55",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.09 320.13C103.15 319.85 103.23 319.62 103.33 319.42C103.55 319.01 103.88 318.79 104.31 318.77C104.74 318.75 105.27 318.91 105.89 319.27C106.29 319.5 106.66 319.82 106.99 320.21C107.33 320.61 107.6 321.05 107.82 321.52C108.04 322.01 108.17 322.48 108.2 322.94V323.09L103.08 320.13M105.91 317.35C105.24 316.96 104.61 316.74 104.04 316.69C103.46 316.63 102.97 316.74 102.55 317C102.13 317.27 101.81 317.68 101.57 318.23C101.34 318.79 101.21 319.48 101.21 320.32C101.21 321.38 101.42 322.43 101.82 323.47C102.23 324.52 102.81 325.49 103.53 326.37C104.26 327.25 105.09 327.97 106.04 328.52C106.47 328.77 106.91 328.96 107.36 329.07C107.81 329.19 108.24 329.24 108.63 329.23C109.04 329.23 109.38 329.13 109.66 328.97L108.76 326.96C108.3 327.16 107.88 327.23 107.49 327.18C107.1 327.13 106.68 326.98 106.23 326.71C105.59 326.34 105.02 325.86 104.54 325.29C104.05 324.71 103.67 324.07 103.41 323.36C103.21 322.83 103.08 322.29 103.04 321.73L110.05 325.77L110.07 324.89C110.08 324.16 109.99 323.41 109.79 322.67C109.59 321.92 109.3 321.21 108.93 320.53C108.55 319.85 108.1 319.24 107.59 318.68C107.08 318.12 106.52 317.67 105.93 317.33",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 325.15L117.2 324.11L117.17 334.75L118.97 335.79L119 325.15Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.09 319.65C117.71 319.43 117.42 319.38 117.21 319.5C116.99 319.62 116.88 319.88 116.88 320.27C116.88 320.69 116.99 321.07 117.19 321.42C117.4 321.77 117.7 322.06 118.08 322.28C118.46 322.5 118.74 322.54 118.96 322.42C119.18 322.3 119.29 322.05 119.29 321.66C119.29 321.24 119.19 320.86 118.98 320.51C118.77 320.15 118.46 319.87 118.09 319.65Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.3 338.67C126.71 338.33 126.16 337.89 125.67 337.34C125.17 336.8 124.75 336.19 124.38 335.52C124.01 334.84 123.73 334.13 123.54 333.39C123.35 332.65 123.25 331.91 123.25 331.15C123.25 330.39 123.35 329.76 123.55 329.24C123.75 328.73 124.03 328.35 124.4 328.1C124.77 327.86 125.2 327.75 125.69 327.77C126.18 327.8 126.73 327.99 127.33 328.33C127.93 328.67 128.47 329.11 128.96 329.66C129.45 330.2 129.88 330.81 130.24 331.49C130.6 332.16 130.88 332.87 131.08 333.61C131.28 334.36 131.38 335.1 131.38 335.84C131.38 336.58 131.27 337.21 131.07 337.72C130.86 338.23 130.58 338.61 130.22 338.87C129.85 339.13 129.43 339.24 128.93 339.21C128.43 339.18 127.89 338.99 127.29 338.65M127.34 326.22C126.48 325.72 125.69 325.45 124.96 325.39C124.23 325.34 123.59 325.48 123.05 325.82C122.51 326.16 122.08 326.69 121.79 327.4C121.49 328.11 121.34 329 121.33 330.05C121.32 331.1 121.47 332.16 121.77 333.22C122.07 334.27 122.48 335.28 123.02 336.25C123.55 337.22 124.19 338.09 124.92 338.88C125.65 339.66 126.44 340.3 127.3 340.8C128.16 341.3 128.95 341.57 129.68 341.63C130.41 341.68 131.04 341.53 131.59 341.19C132.13 340.84 132.56 340.31 132.85 339.6C133.15 338.88 133.3 338.01 133.31 336.97C133.32 335.93 133.16 334.89 132.87 333.83C132.57 332.78 132.16 331.76 131.62 330.79C131.08 329.82 130.45 328.94 129.72 328.15C128.99 327.37 128.2 326.73 127.34 326.23",
    fill: "#459AA4"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_934_722",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 142,
    y: 478,
    width: 102,
    height: 95
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M142.43 513.87L142.53 478.22L243.9 536.75L243.8 572.4L142.43 513.87Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_934_722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.78 505.849V501.219L158.97 502.479C159.72 502.909 160.28 503.429 160.65 504.049C161.02 504.669 161.2 505.339 161.2 506.049C161.2 506.759 161 507.229 160.63 507.429C160.25 507.639 159.7 507.529 158.96 507.099L156.78 505.839M158.98 500.629L154.83 498.229L154.79 512.039L156.76 513.179L156.78 507.659L158.28 508.529L161.04 515.65L163.4 517.009L160.44 509.569C161.39 509.849 162.08 509.749 162.54 509.279C163 508.809 163.23 508.119 163.23 507.219C163.23 506.459 163.07 505.669 162.76 504.859C162.45 504.059 161.97 503.279 161.33 502.529C160.69 501.789 159.91 501.159 158.99 500.629",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.39 512.389L172.42 511.249L172.4 517.349C172.4 518.329 172.18 518.959 171.75 519.239C171.31 519.509 170.73 519.439 169.99 519.009C169.25 518.579 168.67 517.979 168.25 517.219C167.82 516.439 167.61 515.569 167.61 514.589L167.63 508.489L165.68 507.359L165.66 513.799C165.66 514.799 165.83 515.739 166.16 516.639C166.49 517.539 166.97 518.339 167.56 519.039C168.15 519.739 168.82 520.309 169.57 520.739C170.14 521.069 170.67 521.239 171.17 521.279C171.68 521.309 172.08 521.189 172.39 520.919V522.209L174.36 523.349L174.39 512.399",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.82 525.859C181.33 525.579 180.86 525.159 180.41 524.609C179.97 524.059 179.61 523.429 179.34 522.709C179.07 521.989 178.94 521.249 178.94 520.499C178.94 519.749 179.08 519.169 179.35 518.769C179.63 518.369 179.98 518.149 180.43 518.109C180.88 518.079 181.35 518.209 181.84 518.489C182.33 518.769 182.82 519.199 183.27 519.739C183.72 520.279 184.07 520.909 184.34 521.609C184.61 522.319 184.75 523.049 184.74 523.799C184.73 524.549 184.6 525.129 184.33 525.549C184.06 525.969 183.7 526.189 183.25 526.229C182.8 526.269 182.33 526.149 181.82 525.849M178.97 511.269L177 510.129L176.96 524.839L178.93 525.979V524.399C179.27 525.109 179.72 525.789 180.28 526.449C180.85 527.109 181.5 527.659 182.25 528.079C183.08 528.559 183.84 528.759 184.53 528.669C185.21 528.579 185.76 528.219 186.15 527.569C186.54 526.929 186.74 526.059 186.75 524.959C186.76 523.859 186.56 522.769 186.17 521.689C185.78 520.609 185.24 519.639 184.57 518.779C183.89 517.919 183.13 517.259 182.29 516.769C181.57 516.359 180.92 516.149 180.34 516.149C179.76 516.149 179.3 516.319 178.96 516.659L178.98 511.279",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.69 521.799L188.72 520.659L188.69 531.609L190.66 532.749L190.69 521.799ZM189.74 516.879C189.38 516.669 189.08 516.639 188.84 516.779C188.6 516.919 188.47 517.189 188.47 517.599C188.47 518.009 188.59 518.429 188.83 518.839C189.07 519.259 189.37 519.569 189.73 519.779C190.09 519.989 190.37 520.009 190.61 519.869C190.85 519.729 190.98 519.459 190.98 519.049C190.98 518.639 190.86 518.219 190.62 517.809C190.38 517.389 190.08 517.079 189.74 516.879Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.45 527.439L198.4 526.249L196.44 528.849L194.39 523.939L192.16 522.649L195.23 529.999L192.13 533.599L194.19 534.789L196.14 532.199L198.19 537.099L200.42 538.389L197.36 531.069L200.45 527.439Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.39 532.019L206.42 530.879L206.39 541.829L208.36 542.969L208.39 532.019ZM207.44 527.099C207.08 526.889 206.78 526.859 206.54 526.999C206.3 527.139 206.17 527.409 206.17 527.819C206.17 528.229 206.29 528.649 206.53 529.059C206.77 529.479 207.07 529.789 207.43 529.999C207.79 530.209 208.08 530.229 208.32 530.089C208.56 529.949 208.68 529.669 208.68 529.259C208.68 528.849 208.57 528.439 208.33 528.019C208.09 527.599 207.79 527.289 207.44 527.089",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.449 545.809C215.649 545.349 214.939 544.729 214.319 543.959C213.699 543.179 213.219 542.299 212.859 541.329C212.509 540.349 212.339 539.359 212.339 538.329C212.339 537.299 212.519 536.509 212.869 535.949C213.229 535.389 213.719 535.069 214.339 535.019C214.969 534.969 215.679 535.169 216.469 535.629C217.259 536.089 217.979 536.709 218.589 537.469C219.209 538.239 219.699 539.119 220.049 540.089C220.399 541.059 220.579 542.049 220.569 543.069C220.559 544.089 220.389 544.889 220.029 545.459C219.679 546.029 219.189 546.349 218.559 546.409C217.939 546.469 217.229 546.269 216.429 545.809M216.489 533.639C215.369 532.989 214.339 532.699 213.399 532.769C212.459 532.829 211.709 533.229 211.159 533.989C210.609 534.759 210.339 535.809 210.329 537.159C210.319 538.509 210.599 539.889 211.139 541.289C211.689 542.689 212.429 543.959 213.369 545.099C214.309 546.239 215.339 547.139 216.459 547.789C217.579 548.439 218.629 548.739 219.569 548.679C220.519 548.619 221.259 548.209 221.809 547.439C222.359 546.669 222.629 545.609 222.629 544.249C222.629 542.889 222.369 541.529 221.829 540.139C221.289 538.759 220.549 537.489 219.609 536.339C218.669 535.189 217.639 534.289 216.509 533.639",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.15 542.189L228.55 540.109L228.54 542.179L230.15 543.109L230.12 555.529L232.11 556.679L232.15 542.189Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.59 559.109C238.77 558.629 238.14 557.999 237.68 557.199C237.23 556.399 237 555.539 237 554.629C237 553.719 237.25 553.159 237.74 552.959C238.23 552.759 238.83 552.859 239.54 553.269C240.34 553.729 240.94 554.349 241.34 555.119C241.74 555.889 241.95 556.729 241.95 557.629C241.95 558.529 241.73 559.059 241.31 559.329C240.89 559.609 240.32 559.539 239.59 559.119M239.58 546.119C236.6 544.399 235.1 545.959 235.09 550.819C235.09 552.459 235.22 553.909 235.49 555.169C235.76 556.429 236.23 557.549 236.9 558.539C237.58 559.529 238.51 560.369 239.69 561.059C240.56 561.569 241.32 561.789 241.94 561.729C242.57 561.669 243.04 561.369 243.36 560.829C243.68 560.279 243.84 559.539 243.85 558.619C243.85 557.619 243.69 556.679 243.37 555.769C243.04 554.869 242.59 554.049 242 553.329C241.42 552.619 240.75 552.039 239.99 551.599C239.32 551.209 238.69 551.009 238.12 550.999C237.54 550.999 237.1 551.179 236.8 551.599C236.82 549.749 237.07 548.569 237.52 548.019C237.97 547.479 238.65 547.469 239.57 547.999C240.17 548.349 240.64 548.769 240.97 549.269C241.31 549.769 241.54 550.349 241.66 551.039L243.47 552.089C243.36 550.969 242.97 549.869 242.31 548.769C241.65 547.669 240.74 546.789 239.59 546.129",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.24 478.629C142.84 478.399 142.53 478.589 142.53 479.039L142.43 513.059C142.43 513.509 142.74 514.049 143.14 514.279C143.54 514.509 143.85 514.319 143.85 513.869L143.95 479.849C143.95 479.399 143.63 478.849 143.24 478.629Z",
    fill: "#459AA4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubixiO16);
export default __webpack_public_path__ + "static/media/RubixiO16.ede71cee88637428ea1d9c56a781e269.svg";
export { ForwardRef as ReactComponent };